import React, { Component, Fragment } from 'react';
import routes from '../../../routers';
import { Breadcrumb, Icon, Menu } from "antd";
import { Link, Route } from "react-router-dom";
import { withTranslation } from "react-i18next";
import * as Func from "../../../helpers/functions";

let arrayBread = [];

class BreadcrumbComponent extends Component {
    renderBreadcrumbLink(route, title){
        if(route.children){
            return <Link to={route.path}>{title || route.title}</Link>
        } else {
            return title || route.title
        }
    }
    render() {
        const { t, routeBread, groupPath, useHomeIcon, extraBreadcrumbs } = this.props;
        const itemRoute = Func.FindIteminArrayRecursive(routes, routeBread);
        arrayBread = [];
        return (
            <Breadcrumb>
                <Breadcrumb.Item>
                    <Link to={`/`}>{useHomeIcon ? <Icon type={'home'} /> : t('navigation.home')}</Link>
                </Breadcrumb.Item>
                {
                    groupPath && routes.map((route, index) => {
                        if (!route?.tagSub) {
                            let title = this.props.t('navigation.' + [route.title]);
                            let group = route.group;
                            if (groupPath === group && group !== 'home') {
                                route.children && route.children.length > 0 && route.children.map((i, k) => {
                                    if (i.path === routeBread) {
                                        arrayBread.push(<Breadcrumb.Item key={k}>
                                            {this.renderBreadcrumbLink(i)}
                                        </Breadcrumb.Item>)
                                    }
                                });
                                return (
                                    <Breadcrumb.Item key={index}>
                                        {this.renderBreadcrumbLink(route, title)}
                                    </Breadcrumb.Item>
                                );
                            }
                        } else {
                            if (itemRoute.item?.tagSub) {
                                if (itemRoute.item.children) {
                                    if ((itemRoute.item.children).length > 0) {
                                        arrayBread = [];
                                        arrayBread.push(<Breadcrumb.Item key={index}>
                                            {this.renderBreadcrumbLink(itemRoute.item, t(`navigation.${itemRoute.item.title}`))}
                                        </Breadcrumb.Item>)
                                    }
                                } else {
                                    route.children.map((i, k) => {
                                        if (i.group === itemRoute.item.group) {
                                            arrayBread.push(<Breadcrumb.Item key={k}>
                                                {this.renderBreadcrumbLink(i, t(`navigation.${i.title}`))}
                                            </Breadcrumb.Item>);
                                            i.children && i.children.length > 0 && i.children.map((i2, k2) => {
                                                if (i2.path === itemRoute.item.path) {
                                                    arrayBread.push(<Breadcrumb.Item key={k2}>
                                                        {this.renderBreadcrumbLink(i2, t(`navigation.${i2.title}`))}
                                                    </Breadcrumb.Item>)
                                                }
                                            })
                                        }
                                    })
                                }
                            }
                        }
                    })
                }
                {arrayBread}
                {(extraBreadcrumbs || []).map((item, index) => (
                    <Breadcrumb.Item key={`extra-${index}`}>
                        {item.path ? <Link to={item.path}>{item.title}</Link> : item.title}
                    </Breadcrumb.Item>
                ))}
            </Breadcrumb>
        );
    }
}

export default withTranslation()(BreadcrumbComponent);
